import * as React from "react"

export function EmptyCollection({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-24 items-center justify-center px-4 py-6 text-center text-xs sm:text-sm text-muted-foreground">
      {children}
    </div>
  )
}
